import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-doughnut-chart',
	templateUrl:'./WaDoughnutChartProPage.html',
	styles: [],
	styleUrls:['./WaDoughnutChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaDoughnutChartProPage
{
	mdContent_330 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaDoughnutChart;
\`\`\``;
	mdContent_331 = `\`\`\`java
new WaDoughnutChart<>()
\`\`\``;
}
